import { makeEntityPair } from '@local_modules/generic/zenflow-financials/intercompany/make-entity-pair'
import { makeGroupedRows } from './make-grouped-rows.js'

export function makeRows (intercoTransactionsAnalysis, context) {
  console.log('makeRows', context)

  const groupingMethod = context.menuOptions.optionGrouping.selectedOption().value
  console.log('groupingMethod', groupingMethod)

  const transactions = intercoTransactionsAnalysis.transactions
  const transactionsRollup = intercoTransactionsAnalysis.transactionsRollup

  const filteredTransactions = filterTransactions(transactions, context)
  console.log('filteredTransactions', filteredTransactions)

  // Sort: largest first, and credit first
  // Ie. aims to identify what matters, in consistent Credit > Debit order
  filteredTransactions.sort((a, b) => {
    return Math.abs(b._converted_amount) - Math.abs(a._converted_amount) || Math.sign(a._converted_amount) - Math.sign(b._converted_amount)
  })
  console.log('filteredTransactions sorted', filteredTransactions)

  if (groupingMethod === 'transactions') {
    return filteredTransactions?.map(function (transaction) {
      return {
        type: 'transaction',
        transaction,
        rowId: transaction.ledger_id
      }
    })
  }

  const rows = makeGroupedRows(filteredTransactions, transactionsRollup, context)

  return rows
}

function filterTransactions (transactions, context) {
  const optionStatement = context.menuOptions.optionStatement.selectedOption().value
  const optionEntity = context.menuOptions.optionEntity.selectedOption().value
  const optionTransactionDebug = context.menuOptions.optionTransactionDebug.selectedOption().value
  console.log('optionStatement', optionStatement)
  console.log('optionEntity', optionEntity)

  transactions.forEach(function (transaction) {
    // Considering passing; except it exclusion cases detectted below
    transaction._isPassingFilter = true

    const passStatement = optionStatement === 'any' || transaction.chart_of_account_statement === optionStatement
    if (!passStatement) transaction._isPassingFilter = false

    const entityPair = makeEntityPair(transaction)
    const passEntity = optionEntity === 'all' || entityPair.includes(optionEntity)
    if (!passEntity) transaction._isPassingFilter = false

    if (optionTransactionDebug !== 'all') {
      if (transaction._isDateChartOfAccountNetZero) transaction._isPassingFilter = false
      if (!transaction.has_no_reversal) transaction._isPassingFilter = false
    }
  })

  const filteredTransactions = transactions.filter(function (transaction) {
    return !(transaction._isPassingFilter === false)
  })

  return filteredTransactions
}
